import React, {useState, useLayoutEffect} from "react";
import {updateQuestionInSurveyAtIdx, validateQuestionAtIndex} from "../../../../../../slices/surveyEditorSlice";
import {connect, useDispatch} from "react-redux";
import MatrixRowsChoiceEdit from "./MatrixRowsChoiceEdit";
import MatrixColumnsChoiceEdit from "./MatrixColumnsChoiceEdit";
import {validateChoices} from "../../../../../../utils/SurveyValidationUtils"

function CommonSelectsQuestionEdit(props) {
    const dispatch = useDispatch();
    const optionsResult = props.questionData.type === "selects" ? validateChoices(props.questionData.selects[0].options) : undefined;
    const [selectsValidationResult, setSelectsValidationResult] = useState(validateChoices(props.questionData.selects));
    const [optionsValidationResult, setOptionsValidationResult] = useState(optionsResult);

    useLayoutEffect(() => {
        setSelectsValidationResult(validateChoices(props.questionData.selects));
    }, [props.questionData.selects]);

    useLayoutEffect(() => {
        if (props.questionData.type === "selects")
            setOptionsValidationResult(validateChoices(props.questionData.selects[0].options));
    }, [props.questionData.selects[0]?.options]);

    const handleQuestionChoiceTextChange = (event, choiceIdx, isRows) => {
        const newText = event.target.value;
        if (newText || newText === "") {
            const {questionData, idx} = props;
            let newQuestionData = JSON.parse(JSON.stringify(questionData));
            isRows ? newQuestionData.selects[choiceIdx].label = newText : newQuestionData.selects.forEach(element => element.options[choiceIdx].label = newText);
            props.validateQuestionAtIndex(idx, newQuestionData);

            const choicesToBeFiltered = isRows ? newQuestionData.selects : newQuestionData.selects[0].options;
            let choiceValidationResult = validateChoices(choicesToBeFiltered);

            isRows ? setSelectsValidationResult(choiceValidationResult) : setOptionsValidationResult(choiceValidationResult);
        }
    };

    const handleAddNewChoice = (event, handleAddNew) => {
        const {questionData, idx} = props;
        let newQuestionData = JSON.parse(JSON.stringify(questionData));

        handleAddNew(newQuestionData.selects);
        dispatch(updateQuestionInSurveyAtIdx({idx: idx, questionData: newQuestionData}));
    };

    const handleRemoveChoice = (event, choiceIdx, handleRemove) => {
        const {questionData, idx} = props;
        let newQuestionData = JSON.parse(JSON.stringify(questionData));

        handleRemove(newQuestionData.selects, choiceIdx);
        props.validateQuestionAtIndex(idx, newQuestionData);
    };

    return (
        <React.Fragment>
            <MatrixRowsChoiceEdit
                questionData={props.questionData}
                questionValid={props.questionValid}
                errorMessages={selectsValidationResult}
                handleAddNewChoice={handleAddNewChoice}
                handleRemoveChoice={handleRemoveChoice}
                handleQuestionChoiceTextChange={handleQuestionChoiceTextChange}
            />

            {props.questionData.type === "selects" &&
            (<MatrixColumnsChoiceEdit
                questionData={props.questionData}
                idx={props.idx}
                questionValid={props.questionValid}
                errorMessages={optionsValidationResult}
                handleAddNewChoice={handleAddNewChoice}
                handleRemoveChoice={handleRemoveChoice}
                handleQuestionChoiceTextChange={handleQuestionChoiceTextChange}
            />)
            }
        </React.Fragment>
    );
}

function mapStateToProps(state) {
    return {};
}

const mapDispatchToProps = {validateQuestionAtIndex};

export default connect(mapStateToProps, mapDispatchToProps)(CommonSelectsQuestionEdit);